import template from './equifaxAuth.template.html';

export default {
  bindings: {
    onFinish: '&'
  },
  controller: class controller {
    constructor($mdDialog) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;

      this.initialize = () => {
        $mdDialog
          .show({
            locals: {},
            template,
            controllerAs: '$ctrl',
            multiple: true,
            controller() {
              const self = this;
              self.username = '';
              self.password1 = '';
              self.password2 = '';

              self.arePasswordMatching = () => {
                if (self.password1 && self.password2) {
                  return self.password1 === self.password2;
                }
                return true;
              };

              self.canSave = () => self.username && self.password1 && self.password2;

              self.confirm = () => {
                if (self.canSave() && self.arePasswordMatching()) {
                  $mdDialog.hide({ username: self.username, password: self.password1 });
                }
              };
              self.cancel = () => {
                $mdDialog.hide(false);
              };
            },
            clickOutsideToClose: false
          })
          .then((res) => {
            ctrl.onFinish({ status: res });
          });
      };

      this.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
